function enterFullScreen(): Promise<void> | undefined {
  if (document.fullscreenElement) return;
  return document.documentElement.requestFullscreen();
}

function exitFullScreen(): Promise<void> | undefined {
  try {
    if (document.fullscreenElement) return document.exitFullscreen();
  } catch (e) {}
  return;
}

async function unlock(): Promise<void> {
  try {
    return await screen.orientation.unlock();
  } catch (e) {}
}

async function lock(newOrientation: OrientationLockType): Promise<void> {
  try {
    return await screen.orientation.lock(newOrientation);
  } catch (e) {}
}

async function requestCameraAccess(): Promise<void> {
  return new Promise(async (res) => {
    try {
      const media = await navigator.mediaDevices.getUserMedia({ video: {} });
      media.getTracks().forEach((t) => t.stop());
    } catch (e) {
    } finally {
      res();
    }
  });
}

function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
}

function isAndroid() {
  return /Android/i.test(navigator.userAgent);
}

function isApple() {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

export default {
  enterFullScreen,
  exitFullScreen,
  unlock,
  lock,
  requestCameraAccess,
  isMobile,
  isAndroid,
  isApple
};
